import { render, staticRenderFns } from "./PPagination.vue?vue&type=template&id=fd0f60ec"
import script from "./PPagination.vue?vue&type=script&lang=js"
export * from "./PPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports